/* tslint:disable */
/* eslint-disable */
/**
 * OiOi content management API
 * OiOi content management API spec
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MqttResourceLockUpdate
 */
export interface MqttResourceLockUpdate {
    /**
     * 
     * @type {string}
     * @memberof MqttResourceLockUpdate
     */
    readonly resourceId: string;
    /**
     * 
     * @type {boolean}
     * @memberof MqttResourceLockUpdate
     */
    readonly locked: boolean;
}

export function MqttResourceLockUpdateFromJSON(json: any): MqttResourceLockUpdate {
    return MqttResourceLockUpdateFromJSONTyped(json, false);
}

export function MqttResourceLockUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): MqttResourceLockUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resourceId': json['resourceId'],
        'locked': json['locked'],
    };
}

export function MqttResourceLockUpdateToJSON(value?: MqttResourceLockUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
    };
}


